/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format
import React from 'react';
import Helpers from '../../utils/Helpers';

export default function Card(props) {
  const usePlaceholder = (e) => {
    e.target.src = 'https://app.everviz.com/static/images/table.png';
    e.target.className = 'object-scale-down object-center h-full w-full p-6';
  };
  const name = Helpers.stripHtml(props.name);

  return (
    <div
      className={'project-card cursor-pointer ' + props.className}
      onDoubleClick={props.onDoubleClick}
      onClick={props.onClick}
    >
      <div className={'flex flex-col relative justify-between'}>
        <figure
          className={`group rounded-t-md relative cursor-pointer overflow-hidden ${props.wizard ? 'h-16' : 'h-20'}`}
        >
          <span>
            <img
              className="lazy w-full"
              draggable="false"
              src={props.thumbnail_url}
              onError={(e) => usePlaceholder(e)}
            />
          </span>
        </figure>

        <div className="text rounded-b-md">
          <span className="text-2xs font-bold theme-text">{props.text ?? 'THEME'}</span>

          <span title={name} className={'font-bold h-10 no-underline block truncate'}>
            {name}
          </span>
        </div>
      </div>
    </div>
  );
}
